import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { HttpClient, HttpHeaders} from '@angular/common/http';
import { tap, catchError } from 'rxjs/operators';
import { environment } from '../../../environments/environment';

export interface DeleteDrugPayload {
  id:          number;
  adjusterId:  String;   // UUID **as-string**
  memberName:  String;
  drugName:    String;
}

@Injectable({
  providedIn: 'root'
})
export class DrugLookupService {
  data: any;
  url = environment.apiBase;
  apiBaseAraya = environment.apiBaseAraya;
  selectedMemberId;
  constructor(private http: HttpClient) {}

  getMemberDetails(memberId): Observable<any> {
    return this.http
      .get(this.url + 'api/Members?memberid=' + memberId)
      .pipe(catchError(this.handleError));
  }

  getDrugDetails(member, body): Observable<any> {
    return this.http
      .get(
        this.url +
          'api/Drugs/' +
          member +
          '?drugName=' +
          body.name +
          '&ndcNumber=' +
          body.ndcNumber +
          '&gpiNumber=' +
          body.gpiNumber
      )
      .pipe(catchError(this.handleError));
  }

  getCommonUses(body): Observable<any> {
    return this.http
      .get(this.url + 'api/Drugs/GetDrugUses?gpiNumber=' + body)
      .pipe(tap(res => {}));
  }

  postDrug(body: any): Observable<any> {
    // existing base query string
    let queryParams =
      `?memberId=${encodeURIComponent(body.memberId)}` +
      `&startDate=${encodeURIComponent(body.validityStartDate)}` +
      `&endDate=${encodeURIComponent(body.validityEndDate)}` +
      `&adjusterName=${encodeURIComponent(body.adjusterName)}` +
      `&drugNdc=${encodeURIComponent(body.ndcNumber)}` +
      `&drugName=${encodeURIComponent(body.drugName)}` +
      `&adjusterId=${encodeURIComponent(body.adjusterId)}` +
      `&memberName=${encodeURIComponent(body.memberName)}`;
  
    const pin = localStorage.getItem('pin') || '';
    const preId = localStorage.getItem('preId') || '';
    if (pin) {
      queryParams += `&pin=${encodeURIComponent(pin)}`;
    }
    if (preId) {
      queryParams += `&preId=${encodeURIComponent(preId)}`;
    }
  
    // make the POST call with the final query params
    return this.http.post(
      this.apiBaseAraya + 'api/drugs/patient-auth' + queryParams,
      null,
      { responseType: 'text' }
    ).pipe(
      tap(res => {})
    );
  }
  

  updateDrug(body: any): Observable<any> {
    const headers = new HttpHeaders().set(
      'Content-Type',
      'application/json; charset=utf-8'
    );
    return this.http
      .put(this.apiBaseAraya + 'api/drugs/patient-auth', body, {
        headers,
        responseType: 'json' // or 'text' if your server returns plain text
      })
      .pipe();
  }
  

  blockDrugs(body): Observable<any> {
    return this.http
      .put(this.url + 'api/Drugs', body, { responseType: 'text' })
      .pipe();
  }

  preferedDrugs(memberId): Observable<any> {
    return this.http
      .get(this.url + 'api/Drugs?memberId=' + memberId)
      .pipe(tap(res => {}));
  }

  deleteDrug(body: any): Observable<any> {
    const options = {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
      body,
      responseType: 'text' as 'text'   // legal workaround on Angular 6
    };
    return this.http
             .delete(this.apiBaseAraya + 'api/drugs/patient-auth', options)
             .pipe(catchError(this.handleError));
  }  

  handleError(error) {
    let errorMessage = '';
    if (error.error instanceof ErrorEvent) {
      // client-side error
      errorMessage = `Error: ${error.error.message}`;
    } else {
      // server-side error
      if (error.status >= 400 && error.status < 500) {
        errorMessage = 'Action failed due to bad request';
      } else if (error.status >= 500) {
        errorMessage = 'Action failed due to server side issue';
      }
    }
    return throwError(errorMessage);
  }

  getPdfDownload(body): Observable<any> {
    const query =
      '0?drugName=' +
      body.name +
      '&ndcNumber=' +
      body.ndcNumber +
      '&gpiNumber=' +
      body.gpiNumber;
    const value = {
      key: 0,
      value: query +'&clientId='+(sessionStorage.getItem('clientId') || localStorage.getItem('clientId'))
    };
    return this.http
      .post(this.url + 'api/Drugs/DrugResultAsPdf', value, {
        responseType: 'blob'
      })
      .pipe(catchError(this.handleError));
  }
}
